export const Permission = {
  OrgView: 10,
  OrgCreate: 11,
  OrgUpdate: 12,
  OrgDelete: 13,
  EventView: 20,
  EventCreate: 21,
  EventUpdate: 22,
  EventDelete: 23,
  UserView: 100,
  UserCreate: 101,
  UserUpdate: 102,
  UserDelete: 103,
  UserPasswordChange: 104,
  AoiView: 200,
  AoiCreate: 201,
  AoiUpdateInfo: 202,
  AoiUpdateGeometry: 203,
  AoiDelete: 204,
  GeoJsonTypeView: 300,
  GeoJsonTypeCreate: 301,
  GeoJsonTypeStyleUpdate: 302,
  GeoJsonTypeNameUpdate: 303,
  GeoJsonTypeDelete: 304,
  AnnotationView: 1100,
  AnnotationCreate: 1101,
  AnnotationUpdate: 1102,
  AnnotationDelete: 1103
};